import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface DisplayAmountProps {
  value: {
    text: string;
    text_color: string;
    font_size: string;
  };
  explanation: {
    text: string;
    text_color: string;
    font_size: string;
  };
}

const DisplayAmount: React.FC<DisplayAmountProps> = ({ value, explanation }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, amount: 0 });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 2, type: "spring", bounce: 0 },
        },
      }}
      className="contain w-full flex flex-col text-center items-center justify-between gap-4"
    >
      <div
      style={{
        color: value.text_color,
        fontSize: value.font_size,
      }}
        className="flex-1 font-normal font-bungeeinline flex-wrap max-sm:text-[10px]"
        
      >
        {value.text}
      </div>

      <div
        className="flex-1 font-normal font-montserrat flex-wrap max-sm:text-base"
        style={{
          color: explanation.text_color,
          fontSize: explanation.font_size,
        }}
      >
        {explanation.text}
      </div>
    </motion.div>
  );
};

export default DisplayAmount;
